// PENDING: remove these exceptions once this file is migrated
/* eslint-disable camelcase */
import { FavoriteItineraryButton } from '@rcg/favorites';

import { useFeatureFlags } from '@hooks/LaunchDarkly/useFeatureFlags';
import { FAVORITES_SIZE_BUTTON } from 'components/SearchPage/Constants';
import { AnalyticsContext } from 'contexts/AnalyticsContext';
import { TRACKING_INTERACTION, VDS_ID } from 'contexts/AnalyticsContext/Constants';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { trackOnFavoriteAction } from 'lib/ui-analytics/events/onFavoritesAction';
import { getCookie } from 'lib/utilities/Cookies';
import { useContext } from 'react';
import { CruiseCardFavoriteButtonProps } from './CruiseCardUserFavoriteButton.types';

function CruiseCardUserFavoriteButton({ cruise, count, index, srcComponent }: Readonly<CruiseCardFavoriteButtonProps>) {
	const { userFavorites, locale, brand }: any = useContext(CruiseSearchContext);
	const { utagFavoritesWatchlistCardClicked, getEventFavorites }: any = useContext(AnalyticsContext);
	const { enableDataLayerUnification } = useFeatureFlags();

	const { FAVORITES_AND_WATCHLIST: { CLICK_FAVORITE_BUTTON } = {} } = TRACKING_INTERACTION;

	const sendEventFavorites = ({ isSaved }) => {
		if (enableDataLayerUnification) {
			trackOnFavoriteAction({ cruise, cruiseIndex: index + 1, resultsLength: count, locale, isSaved, srcComponent });
		} else {
			const eventFavoriteButton = getEventFavorites(userFavorites, cruise.id, isSaved);

			if (eventFavoriteButton) {
				utagFavoritesWatchlistCardClicked(CLICK_FAVORITE_BUTTON, eventFavoriteButton, {
					...cruise,
					locale,
					searchIndex: index + 1,
					resultsLength: count,
					brand,
					vdsId: getCookie(VDS_ID),
				});
			}
		}
	};

	return <FavoriteItineraryButton id={cruise.id} size={FAVORITES_SIZE_BUTTON} onChange={sendEventFavorites} />;
}

export default CruiseCardUserFavoriteButton;
